// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"267ffd1c","455":"4e4ae311","977":"c7131539"}[chunkId] + ".chunk.js";
};